/* eslint-disable @typescript-eslint/no-redeclare */
/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable react/prop-types */
/* eslint-disable @typescript-eslint/no-unused-vars */
import InputBase from '@mui/material/InputBase';
import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';
import React from 'react';
import Box from '@mui/material/Box';
import './style.css';
import Step from '../../../components/Step/Step';
import assets from '../../../assets/index';
import { useApi } from '../../../hooks/userApi';
import { useContext, useEffect, useState } from 'react';
import { LoadingContext } from '../../../context/Loading/LoadingContext';
import PrintPDF from '../../../components/PDF/PrintPDF';
import { PDFDownloadLink, BlobProviderProps } from '@react-pdf/renderer';
import { formatDinheiro } from '../../../utils/formatDinheiro';
import { addHours, format, parseISO } from 'date-fns';
import { toZonedTime, format as formatTz } from 'date-fns-tz';

const Title = (props) => {
  return (
    <div className="search">
      <div className="title">{props.title}</div>
      {/* <div className="inputSearch">
        <InputBase
          sx={{ p: "5px" }}
          fullWidth
          placeholder="Busque por um produto"
          inputProps={{ "aria-label": "busque por um produto" }}
        />
        <IconButton
          type="button"
          sx={{ p: "5px", color: "green" }}
          aria-label="search"
        >
          <SearchIcon />
        </IconButton>
      </div> */}
    </div>
  );
};

const PDF = ({ orcamento }) => {
  const [vendedor, setVendedor] = useState<any>({});
  const [cliente, setCliente] = useState<any>({});
  const [produtos, setProdutos] = useState<any>([]);
  const [frete, setFrete] = useState(0);
  const [descontoFrete, setDescontoFrete] = useState(0);
  const [valor, setValor] = useState(0);
  const [valorTotal, setValorTotal] = useState(0);
  const [valorComDesconto, setValorComDesconto] = useState(0);
  const [valorIPI, setValorIPI] = useState(0);
  const api = useApi();

  const getVendedor = async () => {
    const vendedorData = orcamento?.[0].orcamento.vendedor;
    console.log('CheckoutPDF - Dados originais do vendedor:', vendedorData);
    setVendedor(vendedorData);

    if (vendedorData && vendedorData.id) {
      try {
        const response = await api.get(`/vendedor/${vendedorData.id}`);
        console.log('CheckoutPDF - Resposta da API:', response);
        if (response.status) {
          console.log('CheckoutPDF - Dados atualizados do vendedor:', response.mensagem);
          setVendedor(response.mensagem);
        }
      } catch (e) {
        console.error('CheckoutPDF - Erro ao carregar dados atualizados do vendedor:', e);
      }
    }
  };

  const getCliente = () => {
    setCliente(orcamento?.[0].orcamento.cliente);
  };

  console.log(orcamento);
  console.log(orcamento?.[0].orcamento);
  console.log(orcamento?.[0].orcamento.pagamento);
  console.log(orcamento?.[0]);

  const getProdutos = () => {
    orcamento.map((e, index) => {
      const p = { ...e.produto };
      p.valor = e.valor;
      p.quantidade = e.quantidade;
      p.valorFrete = e.valorFrete;
      setProdutos((produtos) => [...produtos, p]);
      console.log(index);
      setFrete((frete) => frete + Number(p.valorFrete));
      setValor((valor) => valor + p.valor * p.quantidade);
      const ipi = orcamento?.[index].ipi / 100;
      const TotalItens = p.valor * p.quantidade;
      const TotalIpi = p.valor * ipi * p.quantidade + Number((p.valorFrete * ipi).toFixed(2));
      const TotalFrete = Number(p.valorFrete);
      setValorIPI((valorIPI) => Number(valorIPI) + Number(TotalIpi));
      setValorTotal(
        (valorTotal) =>
          Number(valorTotal.toFixed(4)) +
          Number(TotalItens.toFixed(4)) +
          Number(TotalIpi.toFixed(4)) +
          Number(TotalFrete.toFixed(4)),
      );
    });
  };

  useEffect(() => {
    setFrete(0.0);
    setValor(0);
    setProdutos([]);
    getVendedor();
    getCliente();
    getProdutos();
    setDescontoFrete(orcamento?.[0].descontoFrete);
  }, []);

  useEffect(() => {
    const calculaDesconto = () => {
      const despesas = Number(orcamento?.[0].orcamento?.despesas) || 0;
      const descontoFrete = Number(orcamento?.[0].orcamento?.descontoFrete) || 0;

      const valorTotalResult = valorTotal - descontoFrete + despesas;

      const valorTotalComDesconto = orcamento?.[0].orcamento.negociacao.includes('3% de Desconto À VISTA')
        ? valorTotalResult - valorTotalResult * 0.03
        : valorTotalResult;

      setValorComDesconto(valorTotalComDesconto);
    };

    calculaDesconto();
  }, [valorTotal]);
  const adjustedValidade = parseISO(orcamento?.[0].orcamento.validade);
  const timeZone = 'America/Sao_Paulo'; // Defina o fuso horário desejado
  const adjustedEmbarque = toZonedTime(parseISO(orcamento?.[0].orcamento.embarque), timeZone);
  return (
    <Box className="pdfView">
      <div className="header">
        <div className="logo">
          <img src={assets.images.logoPDF} />
        </div>
        <div className="header-text">
          <div>Primaza Termoplástico LTDA | CNPJ: 06.350.668/0001-45</div>
          <div>Av. Presidente Kennedy, 3400 | Panambi-RS | 98280-000</div>
        </div>
        <div className="header-text" style={{ marginRight: 20 }}>
          <div>Fone: 55 3375-8443 / WhatsApp: 55 99675-4640</div>
          <div>vendas@primaza.com.br</div>
        </div>
      </div>

      <div className="orcamento">
        <div className="orcamento-titulo">Orçamento {orcamento?.[0].orcamento.cod}</div>
        <div className="gerado">
          Gerado em {new Date(orcamento?.[0].orcamento.created_at).toLocaleDateString('pt-br')}
        </div>
        <div className="orcamentos">Dados do cliente:</div>
        <div className="bloco-texto" style={{ display: 'flex' }}>
          <div style={{ marginRight: '20px' }}>
            {cliente?.nome && (
              <p>
                Nome: <strong>{cliente.nome}</strong>
              </p>
            )}
            {cliente?.cpfCNPJ && !cliente.cpfCNPJ.startsWith('lead') && (
              <p>
                CPF/CNPJ: <strong>{cliente.cpfCNPJ}</strong>
              </p>
            )}
            {cliente?.tipoDocumento && cliente?.documento && (
              <p>
                Documento:
                <strong>
                  {cliente.tipoDocumento} - {cliente.documento}
                </strong>
              </p>
            )}
            {cliente?.razaoSocial && (
              <p>
                Razão social: <strong>{cliente.razaoSocial}</strong>
              </p>
            )}
            {cliente?.nomeFantasia && (
              <p>
                Nome fantasia: <strong>{cliente.nomeFantasia}</strong>
              </p>
            )}
          </div>
          <div>
            {cliente?.email && (
              <p>
                E-mail: <strong>{cliente.email}</strong>
              </p>
            )}
            {cliente?.telefone && (
              <p>
                Telefone: <strong>{cliente.telefone}</strong>
              </p>
            )}
            {cliente?.whatsapp && (
              <p>
                Whatsapp: <strong>{cliente.whatsapp}</strong>
              </p>
            )}
            {cliente?.endereco && cliente?.numero && cliente?.cidade && cliente?.cep && (
              <p>
                Endereço:
                <strong>
                  {cliente.endereco} {cliente.numero} {cliente.complemento} - {cliente.cidade} {cliente.cep}
                  <p>{cliente.estado}</p>
                </strong>
              </p>
            )}
          </div>
        </div>
        <div className="orcamento-produto">
          <div className="orcamentos">Produto:</div>
          <table className="table">
            <thead>
              <tr className="table-row">
                <th>SKU</th>
                <th>Produto</th>
                <th>Qtde.</th>
                <th>Unitário</th>
                <th>Frete</th>
                <th>IPI</th>
                <th>Vlr. IPI</th>
                <th>Vlr. Total</th>
              </tr>
            </thead>
            <tbody>
              {produtos.map((produto, index) => (
                <tr key={index} className="table-row">
                  <td>{produto.SKU}</td>
                  <td style={{ width: '100%' }}>{produto.nome}</td>
                  <td>{produto.quantidade}</td>
                  <td>{formatDinheiro(produto.valor, 4)}</td>
                  <td>{formatDinheiro(produto.frete)}</td>
                  <td>{orcamento?.[index].ipi}</td>
                  <td>{formatDinheiro(produto.valor * produto.quantidade * (orcamento?.[index].ipi / 100))}</td>
                  <td>{formatDinheiro(produto.valor * produto.quantidade)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div style={{ display: 'flex', flexDirection: 'row', marginTop: 22 }}>
          <div>
            <div className="orcamentos">Observações:</div>
            <div className="observacoes">
              {orcamento?.[0].orcamento?.observacoes ? orcamento?.[0].orcamento?.observacoes : 'Nenhuma observação'}
            </div>
          </div>
          <div style={{ marginRight: 32 }}>
            <div className="bloco-valores-checkout">
              <div className="span">
                <span>
                  Valor total itens: <strong>{formatDinheiro(valor)}</strong>
                  <br />
                  Valor IPI: <strong>{formatDinheiro(valorIPI, 4)}</strong>
                  <br />
                  {Number(orcamento?.[0].orcamento?.descontoFrete) > 0 && (
                    <>
                      Desconto: <strong>{formatDinheiro(orcamento?.[0].orcamento?.descontoFrete)}</strong>
                      <br />
                    </>
                  )}
                  Valor total do frete: <strong>{formatDinheiro(frete)}</strong>
                  <br />
                  Despesas: <strong>{formatDinheiro(orcamento?.[0].orcamento?.despesas)}</strong>
                </span>
              </div>
              <div className="orcamento-valor">
                Total:{' '}
                <span>
                  {formatDinheiro(
                    valorTotal -
                      Number(Number(orcamento?.[0].orcamento?.descontoFrete).toFixed(2)) +
                      Number(orcamento?.[0].orcamento?.despesas),
                    2,
                  )}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-end', marginRight: 32 }}>
          <div className="condicoes">
            {orcamento?.[0].orcamento.negociacao.length > 0 && (
              <>
                <div style={{ marginBottom: 2 }}>
                  <span>Método de pagamento:</span>
                  <strong> {orcamento?.[0].orcamento.pagamento.nome} - </strong>
                  {orcamento?.[0].orcamento.negociacao.map((item, index) => (
                    <React.Fragment key={index}>
                      <strong>{item}</strong>
                      {index < orcamento?.[0].orcamento.negociacao.length - 1 && '-'}
                    </React.Fragment>
                  ))}
                </div>
              </>
            )}
            <div style={{ color: '#136033', fontWeight: 'bold' }}>
              Frete:
              {orcamento?.[0].orcamento?.tipofrete}
            </div>
            <div>
              Prazo de embarque:
              <strong>{format(adjustedEmbarque, 'dd/MM/yyyy')}</strong>
            </div>
            {orcamento?.[0].orcamento.negociacao.includes('3% de Desconto À VISTA') && (
              <div>
                Total à vista com desconto: <strong>{formatDinheiro(valorComDesconto)}</strong>
              </div>
            )}
            <div className="orcamento-total">
              <div className="orcamento-validade">
                Validade da proposta:
                <span>{format(adjustedValidade, 'dd/MM/yyyy')}</span>
              </div>
            </div>
          </div>
        </div>
        <div className="orcamentos">Dados do vendedor:</div>
        <div className="bloco-texto">
          <p>
            Nome: <strong>{vendedor?.nome}</strong>
          </p>
          <p>
            E-mail:{' '}
            <strong>
              {(() => {
                console.log('CheckoutPDF - vendedor no render:', vendedor);
                console.log('CheckoutPDF - emailContato:', vendedor?.emailContato);
                console.log('CheckoutPDF - email:', vendedor?.email);
                console.log('CheckoutPDF - Todos os campos do vendedor:', Object.keys(vendedor || {}));

                const emailFields = Object.keys(vendedor || {}).filter((key) => key.toLowerCase().includes('email'));
                console.log('CheckoutPDF - Campos que contêm "email":', emailFields);

                const userFromSession = JSON.parse(sessionStorage.getItem('user') || '{}');
                console.log('CheckoutPDF - Usuário do sessionStorage:', userFromSession);

                const emailFinal =
                  vendedor?.emailContato && vendedor.emailContato !== 'SEM'
                    ? vendedor.emailContato
                    : vendedor?.email || userFromSession.email || 'N/A';
                console.log('CheckoutPDF - Email final calculado:', emailFinal);
                return emailFinal;
              })()}
            </strong>
          </p>
          <p>
            Contato: <strong>{vendedor?.contato}</strong>
          </p>
        </div>
      </div>
    </Box>
  );
};

const CheckoutPDF = () => {
  const api = useApi();
  const idOrcamento = window.location.pathname.split('/').pop();
  const { loading, setLoading, setLoadingMensagem, setLoadingBtn, setLoadingAction, setClearLoading }: any =
    useContext(LoadingContext);

  const items = [
    ['Orçamento', true],
    ['Checkout', true],
    ['Confirmação', true],
    ['PDF', true],
  ];

  const [orcamento, setOrcamento] = useState(null);
  const [nomeArquivo, setNomeArquivo] = useState('');

  const loadOrcamento = async () => {
    setLoading(true);
    try {
      const responses = await api.get('orcamento-produto/orcamento/' + idOrcamento);
      if (responses.length <= 0) {
        setLoadingMensagem('Desculpe, não foi possivel gerar esse orçamento!');
        setLoadingBtn('OK');
        return;
      }
      setLoading(false);
      setOrcamento(responses);
      setNomeArquivo(`Proposta - ${responses[0].orcamento.cod}.pdf`);
    } catch (e) {
      const msg = 'Houve um erro interno, tente mais tarde. ' + e.message;

      setLoadingMensagem(msg);
      setLoadingBtn('OK');
    }
  };

  useEffect(() => {
    loadOrcamento();
  }, []);

  const timeZone = 'America/Sao_Paulo';
  const adjustedEmbarque =
    orcamento && orcamento[0] && orcamento[0].orcamento && orcamento[0].orcamento.embarque
      ? toZonedTime(parseISO(orcamento[0].orcamento.embarque), timeZone)
      : null;

  return (
    <div className="container">
      <div
        style={{
          display: 'flex',
          borderRadius: '0px 0px 48px 48px',
          backgroundImage: `linear-gradient(90deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.2) 100%), url(${assets.images.bgCheckout})`,
          backgroundColor: '#136033',
          backgroundPosition: 'center',
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat',
          backgroundBlendMode: 'multiply, screen, normal',
          padding: ' 32px 200px',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <Title title="Gerador de orçamentos" />
        <Step items={items} />
      </div>
      <Box
        style={{
          display: 'flex',
          gap: '22px',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        {orcamento !== null && <PDF orcamento={orcamento} />}

        {orcamento !== null && (
          <PDFDownloadLink
            document={<PrintPDF orcamento={orcamento} adjustedEmbarque={adjustedEmbarque} />}
            fileName={nomeArquivo}
          >
            {
              (({ blob, url, loading, error }) =>
                loading ? (
                  <button className="btn-v">Criando Documento</button>
                ) : (
                  <button className="btn-v">BAIXAR PDF</button>
                )) as any
            }
          </PDFDownloadLink>
        )}
      </Box>
    </div>
  );
};

export default CheckoutPDF;

// http://localhost:3000/vendedor/checkoutPDF/b3126086-2714-4d7b-8b2b-8282a238f925
